import services from './../../../services/service'; // Service Class

let service = new services();

import {
  ADD_TO_CART,
  REMOVE_FROM_CART
} from '../../../store/mutation-types'
export default {
    name: 'Cart',
    data () {
        return {
          user: {},
          selected_order:[],
          checkout_orders: {},
          delivery_details: [],
          payment_details: {},
          payment_mode:"",
          request_page: "orders",
          checked_out: [],
          processed_checkout_orders: [],
          sorted_cart: [],
          orders: [],
          cart: this.$store.state.cart,
          img_product_url: service.imageProductsURL,
          item_delivery_fee:"",
          delivery_fee: "",
          payment_option: "",
          total_order_amt: 0.0,
          total_orders_amount:0.0,
          total_shipping_fee:0.0,
          states:{},
          cities:[],
          loggedIn: false,
          new_account:true,
          process_count:0,
          checkout_processed:false,
          data_error_message:"",
          data_success_message:"",
          is_logged_in_order_mode:0,
          disable_btn:false,
          loading:true,
          action_loading:false,
          selected_order_shipping_details_state:"",
          selected_order_shipping_details_city:"",
          selected_order_shipping_details_address:"",
        }
      },
    components: {
        
      },
      computed: {
        // a computed getter
        // totalDeliveryFee: function () {
        //     this.sorted_cart.forEach(function(element) {
        //         console.log(element['delivery_option_fee'])
        //         /////this.total_delivery_fee += element['delivery_option_fee']
        //         return element['delivery_option_fee']
        //     });
        // }
      },
     methods:{
        setComponent(attr1,attr2){
            if(attr1 == 'login'){
                this.new_account = false;
            }
            if(attr1 == 'new-account'){
                this.new_account = true;
            }
        },

        
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        removeFromCart (payload) {
            this.$store.commit(REMOVE_FROM_CART, payload)
        },

        getStates(){
            service.getStates(this).then(response => {
                if(response.body.status == 200) {
                    this.states = response.body.data;
                }
            }).catch((err) => {})
        },

        getCities(state){
            this.activate_processing();
            service.getCities(this,state).then(response => {
                if(response.body.status == 200) {
                    this.cities =  response.body.data;
                    this.deactivate_processing();
                }
            }).catch((err) => {this.deactivate_processing()})
        },

       
        login(){
            this.activate_processing();
            service.loginUser(this, this.user).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    localStorage.setItem("sp_user", data.user_name); 
                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                    localStorage.setItem("sp_token_key", data.user_token_key); 
                    this.user = data; 
                    if(!this.new_account){ ///not new account
                        this.is_logged_in_order_mode = 1;
                        this.process_checkout();
                        this.deactivate_processing();
                    }
                }else{
                this.data_error_message = "Sorry, these login details are invalid.";
                this.deactivate_processing();
                }
            }).catch((err) => {
                this.deactivate_processing();
            })
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //this.checkout();
                            this.loggedIn = true;
                            //check if order has a specified url
                            if(this.$route.params.ckid != null){
                                this.order_url = this.$route.params.ckid;
                                this.getCheckoutOrdersByURL();
                            }else{//get orders with this user id
                                this.getCheckoutOrders();
                            }
                            this.checkout_processed = true; //already processed
                            this.loading = false;
                            //..DEPRAC
                            // if(this.$route.query["order"]){
                            //     this.getCheckoutOrder()
                            // }else{
                            //     this.getCheckoutOrders();
                            // }
                            //..DEPRAC
                            this.getUserDeliveryDetails();
                        }, this);
                    }else {
                    // this.$router.push('login');
                    }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                        // console.log(err)
                    }
                })
            }else {
            // this.$router.push('login');
            }
        },


        //local orders stored in forage for NOT-LoggedIn users
        getCheckoutLocalOrder(){
            this.loading = false;
            //use localforage to store and get for now ... if not working well accross points then send to hostdb
            //get from localforage
            this.activate_processing();
            let self = this;
            //serve from forage first
            setTimeout(function(){ 
                localforage.getItem('buy_now_order').then(function(value) {
                    if(value != null){
                        self.checkout_orders = value;
                    }
                }).catch(function(err) {
                    //report error
                    this.deactivate_processing();
                    this.$router.push("orders");  //no checkout items
                });
            }, 500)        
        },

        //logged In User
        getCheckoutOrders(){
            this.activate_processing();
            service.getCheckoutOrders(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.setCheckoutOrders(response);
                }else{
                    this.$router.push("orders");  //no checkout items
                }
            }).catch((err) => {
                this.deactivate_processing();
                this.$router.push("orders");  //no checkout items
            })
        },

        //Order with specified URL
        getCheckoutOrdersByURL(){
            this.activate_processing();
            service.getCheckoutOrder(this, this.order_url).then(response => {
                if(response.body.status == 200) {
                    this.setCheckoutOrders(response);
                }else{
                    this.deactivate_processing();
                    this.$router.push("orders");  //no checkout items
                }
            }).catch((err) => {
                this.deactivate_processing();
                this.$router.push("orders");  //no checkout items
            })
        },

        //set the order responses
        setCheckoutOrders(response){
            //after successful request from remote 
            this.checkout_orders = response.body.data;
            this.total_orders_amount = response.body.data_total_orders_amount;
            this.total_shipping_fee = response.body.data_calculated_shipping_fee;
            this.delivery_details = response.body.data_user_delivery_details;
            this.payment_details = response.body.payment_data;
                    
            //add some settings
            this.checkout_orders.forEach(function(order){
                order.display_delivery = false; //initiate toggle effect
                order.cities = {};
            },this);

            //show processed
            this.checkout_processed = true;
            if(this.new_account){
                this.login();
            }
            this.deactivate_processing();
        },


        getUserDeliveryDetails(){
            service.getUserDeliveryDetails(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.delivery_details = response.body.data;
                }
            }).catch((err) => {
                //console.log(err) //possibly a load payment error
            })
        },



        
        //processing
        //new
        prep_process_checkout(){
            //validate user details
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.user.user_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.user.user_phone).toLowerCase());
            if((email_test == false) || (this.user.user_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                //get from localforage and send to db with users details
                //some settings
                //new-user settings
                this.user.user_has_shipping_details = true;
                this.user.user_password = this.user.user_name; //dummy
                this.user.new_set_account = true;

                //process
                this.process_checkout();
            }//end validate
                
        },

        process_checkout(){
            this.activate_processing();
            //get from localforage and send to db with users details
            this.checkout_orders.forEach(function(processed_checkout) { //groups
                this.order_url = this.checkout_orders[0].order_business + (new Date().getTime());
                processed_checkout.order_mode = this.is_logged_in_order_mode; //not loggedIn
                processed_checkout.order_url = this.order_url;
                if(!this.new_account){
                    processed_checkout.order_user_id = this.user.user_id;
                }else{
                    processed_checkout.order_user_details = this.user;
                }
                    //add each order batch
                service.checkout(this,processed_checkout).then(function(data) {
                    if(data.body.status == 201) {
                        this.process_count++;
                    }
                    if(this.process_count == this.checkout_orders.length){
                        //get tht new users details for login
                    // this.user = data.body.data_user_details;
                        this.getCheckoutOrdersByURL();
                    }
                    this.deactivate_processing();
            
                }).catch((err) => {
                    if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        this.deactivate_processing();
                    } 
                })
            }, this);  
        },

        //...new
        pre_checkout(){
        //check login
        this.preset();
        },
         
        displayDeliveryOptions(order){
            this.selected_order = [];
            this.selected_order = order;
            if(this.selected_order.display_delivery){
                this.selected_order.display_delivery = false;
            }else{
                this.selected_order.display_delivery = true;
            }
        },
       
        calc_delivery_fee(i,option){
            //subtract current delivery fee from sellpoint total order and general total order
            this.total_order_amt -= this.checkout_orders[i].order_delivery_fee; //general
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_delivery_fee; //sellpoint

            //set new sellpoint delivery charge
            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_delivery_city = option.business_delivery_option;

            //add the delivery charge to ellpoint total order and general total order
            this.checkout_orders[i].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_delivery_fee = option.business_delivery_option_price;

            //update delivery fee with new one
            this.total_order_amt += option.business_delivery_option_price; //general
            this.checkout_orders[i].order_total += option.business_delivery_option_price; //sellpoint

            //update address
            this.delivery_details.forEach(function(detail) {
                if(detail.user_delivery_city == option.business_delivery_option){
                    //empty previous city delivery addresses
                    this.checkout_orders[i].order_user_delivery_addresses = [];
                    //now push matching addresses to this city
                    this.checkout_orders[i].order_user_delivery_addresses.push(detail);
                }
                
            }, this);
        },

        calc_product_specific_delivery_fee(i,i2,option){
            //subtract current delivery fee from sellpoint total order and general total order
            this.total_order_amt -= this.checkout_orders[i].order_items[i2].order_delivery_fee; //general
            this.checkout_orders[i].order_total -= this.checkout_orders[i].order_items[i2].order_delivery_fee; //sellpoint

            //set new product delivery charge
            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;
            this.checkout_orders[i].order_items[i2].order_delivery_city = option.business_delivery_option;

            //add the delivery charge to sellpoint total order and general total order
            this.checkout_orders[i].order_items[i2].order_delivery_id = option.business_delivery_option_id;
            this.checkout_orders[i].order_items[i2].order_delivery_fee = option.business_delivery_option_price;

            //update delivery fee with new one
            this.total_order_amt += option.business_delivery_option_price; //general
            this.checkout_orders[i].order_total += option.business_delivery_option_price; //sellpoint

            //update address
            //empty previous city delivery addresses
            this.checkout_orders[i].order_items[i2].order_user_delivery_addresses = [];
                    
            this.delivery_details.forEach(function(detail) {
                if(detail.address_city == option.business_delivery_option_city_id){
                    //now push matching addresses to this city
                    this.checkout_orders[i].order_items[i2].order_user_delivery_addresses.push(detail);
                }else{
                //  console.log("pho"+" "+detail.address_city+"--"+option.business_delivery_option_city_id);
                }
            }, this);
        },

        setUserDeliveryAddress(i,city){
            this.delivery_details.forEach(function(detail) {
                if(detail.user_delivery_city == city){
                    //console.log
                    this.checkout_orders[i].order_user_delivery_address = detail.user_delivery_address;
                }
            }, this);
        },

        //../processing

    
        //payments
        setPaymentOption(option){
            this.payment_mode = option;
        },
        
        processPayment(){
            let process_errors = [];
            //validate all addresses are set
            this.checkout_orders.forEach(function(order) {
                if(order.order_user_delivery_address == undefined && order.order_user_new_delivery_address == undefined){
                    process_errors.push("Please enter delivery address for "+order.order_business)
                }
                // if(order.order_delivery_not_set && (order.order_delivery_city == undefined)){
                //     process_errors.push("Please select delivery location for "+order.order_business)
                // }//commented for now till city issue fixed
                //for order items
                order.order_items.forEach(function(item) {
                    if(item.order_delivery_city){
                        if(item.order_user_delivery_address == undefined && item.order_user_new_delivery_address == undefined){
                            process_errors.push("Please enter delivery address for "+item.product_name);
                        }
                    }
                }, this);
            }, this);
            if(process_errors.length != 0){
                process_errors.forEach(function(error) {
                    toastr.error(error); 
                }, this);
            }else{
                this.processCardPayment(this.payment_details);
                // if(this.payment_mode == "card"){
                //     this.processCardPayment(this.payment_details);
                //     //this.updatePayment(this.payment_details.payment_ref);
                // }
                // if(this.payment_mode == "paycode"){
                //     this.processPayCodePayment();
                // }        
            }
        },

        //a mini quick process payment
        processPaymentMini(){
            let process_errors = [];
            //validate shipping details are set
            if((this.selected_order_shipping_details_state != '') && (this.selected_order_shipping_details_city != '') && (this.selected_order_shipping_details_address != '')){
                this.processCardPayment(this.payment_details);
            }
        },

        //connect to a payment gateway
        processCardPayment(data) {
            //test--//this.updatePayment("ppp")
        let obj = this;
        //this.amount_paid = data.plan_amount;
        var handler = PaystackPop.setup({
        key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
        Name: data.payment_payer_name,
        // email: data.plan_user_email || "admin@sellpoints.ng",
        email: "keneinfostream@gmail.com",
        amount:  (Math.round(data.payment_amount * 100)),//(data.plan_amount * 100), //in kobo
        ref: data.payment_ref,
        metadata: {
            custom_fields: [
                {
                    display_name: "",
                    variable_name: "",
                    value: data.payment_payer_name
                },
                {
                    display_name: "Service",
                    variable_name: "service_type",
                    value: data.payment_service
                }
                
            ]
        },
        
        callback: function(response){
            obj.updatePayment(response.trxref); 
            
        },
        onClose: function(){
            alert('window closed');
        }
        }); 
        handler.openIframe();
        },

        // update payments
        updatePayment(payment_ref) {

            var payload = {
                payment_order_ref: payment_ref,
                payment_order_amount_paid: this.payment_details.payment_amount,
                payment_user_id: this.user.user_id,
                payment_orders: this.checkout_orders,
                payment_details: this.payment_details.payment_service,
                payment_order_delivery_details: {state:this.selected_order_shipping_details_state, 
                                                city:this.selected_order_shipping_details_city, 
                                                address:this.selected_order_shipping_details_address}
            }
            let navi = this.$router;
            
            if(payment_ref != "") {
            service.updatePayment(this, payload).then(data => {
                if(data.body.status == 201) {
                    toastr.success("Payment Processed!", "Success!");
                    
                    if(this.request_page != ''){
                        this.$router.push(this.request_page);
                    }else {
                        this.$router.go('/');
                    }
                }else {
                    //console.log("error")
                    toastr.error('Sorry, could not update payment', 'Warning!');
                }
            }).catch((err) => {
                if(err) {
                    // console.log(err)
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
            }else {
                toastr.error('Something went wrong', 'Warning!');
            }
            
        },

        //....payments

    },
    created(){
        document.title = "Checkout" + " | Gallery";
        //this.preset();
        this.loading = true;
        if((localStorage.getItem("sp_token") != undefined) || (localStorage.getItem("sp_token") != null)){
            this.new_account = false;
            this.preset();
        }else{
            this.getCheckoutLocalOrder();
        }
        this.getStates();
    }
     
}


// WEBPACK FOOTER //
// ./src/pages/Orderpoint/Checkout/script.js